// Module
var code = "<abx-async-select abx-model=\"vm.model\" abx-on-change=\"vm.handleChange($event)\" abx-disabled=\"vm.disabled || vm.state === $root.COMPONENT_STATE.saving\" abx-on-focus=\"vm.handleFocus()\" abx-on-select=\"vm.handleSelect($event)\"></abx-async-select> ";
// Exports
module.exports = code;